module.exports = __webpack_public_path__ + "img/base-location-c61e22c0.png";